import { render, staticRenderFns } from "./party-building.vue?vue&type=template&id=5195be8a&scoped=true&"
import script from "./party-building.vue?vue&type=script&lang=js&"
export * from "./party-building.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195be8a",
  null
  
)

export default component.exports